export const addTrailingSlash = (url: string): string => {
  if (url.endsWith("/")) {
    return url;
  }

  return `${url}/`;
};
